<template>
  <v-navigation-drawer app
    v-model="isActive"
    :width="$_width"
    v-if="!loadingModulos"
  >

    <template #prepend>
      <v-list color="primary" dark>
        <v-list-item>
          <v-list-item-avatar :color="$_avatar ? 'white' : 'primary'" size="32">
            <v-img :src="$_avatar">
              <v-icon color="white" x-large>mdi-account-circle-outline</v-icon>
            </v-img>
          </v-list-item-avatar>
          <v-list-item-content v-if="nomeVendedor">
            <v-list-item-title class="subtitle-2 font-weight-medium">
              {{ nomeVendedor }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">
              {{empresa}}
            </v-list-item-title>
            <div class="subtitle" v-if="dataatt">
              Atualizado: {{dataatt}}
              <v-icon v-if="icon" small class="aviso" color="error">{{icon}}</v-icon>
            </div>

            <v-list-item-subtitle></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>

    <!-- <base-dialog>
      <v-dialog
        v-model="dialog"
        width="500"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Acesso Negado
          </v-card-title>

          <v-card-text>
              Você não possui permissão para acessar.
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialog = false"
            >
              I accept
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </base-dialog> -->

    <v-list dense :shaped="!minVariant">
      <template v-for="(item) in menu" >
        <v-list-item color="primary" :key="item.label" :to="item.route" v-if="(progresso > 99) || (totalItem < 100)">
          <v-list-item-icon>
            <v-icon >{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content >
            <v-list-item-title style='color:rgb(50,50,50)'>{{ item.label }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <template>
        <v-list-item color="primary" class="sair">
          <v-list-item-icon>
            <v-icon>{{'mdi-exit-run'}}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title
            @click='$_getLogout'
            >
            {{ 'Sair' }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import MENU, { menuMapper } from '@/constants/MENUS';

import ToggleNavigationDrawerEvent from '@/events/ToggleNavigationDrawerEvent';
import moment from 'moment-timezone';
import db from '@/plugins/dexie';
import storage from '@/services/storage';
import { TOKEN, TOKENLOCAL } from '@/constants/STORAGE';

import { empresa as formatEmpresa } from '@/utils/local/tabelas';

// import { SetupEnvioLocal } from '@/utils/atualizalocal';

// import BaseDialog from '@/components/core/dialog/Index.vue';

export default {
  name: 'LayoutDefaultNavigarionDrawer',

  components: {
    // BaseDialog,
  },

  data() {
    return {
      isActive: false,
      minVariant: false,
      empresa: null,
      menuArray: [],
      newMenu: [],
      menu: [],
      dataatt: null,
      icon: null,

      loadingModulos: false,
      nomeVendedor: '',
    };
  },

  computed: {
    ...mapState('atualizalocal', [
      'totalItem',
      'progresso',
    ]),
  
    ...mapGetters({
      $_user: 'auth/user',
    }),

    $_isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    $_width() {
      return this.$_isMobile ? 270 : 320;
    },

    $_avatar() {
      return this.$_user?.person?.avatar;
    },

    $_userName() {
      return this.$_user?.person?.name;
    },
  },

  methods: {
    ...mapActions({
      $_logout: 'auth/logout',
      $_empresa: 'empresa/find',
      $_Acesso: 'modulos/metodoAcesso',
    }),

    $_onClickResumo() {
      window.close();
    },

    $_toggleMinVariant() {
      this.minVariant = !this.minVariant;
    },

    $_toggleNavigationDrawerHandler() {
      this.isActive = !this.isActive;
    },

    async $_getLogout() {
      try {
        sessionStorage.clear();
        localStorage.clear();
        await storage.removeItem(TOKEN);
        await storage.removeItem(TOKENLOCAL.tokenlocal);
        await this.$_logout();
      } catch (e) {
        console.error('Erro ao efetuar logout:', e);
      } finally {
        window.location.href = '/';
      }
    },

    async $_buscarNomeVendedor() {
      try {
        const nomeVendedorStorage = sessionStorage.getItem('user:nomevendedor');
        if (nomeVendedorStorage && nomeVendedorStorage !== '---') {
          this.nomeVendedor = nomeVendedorStorage;
          return;
        }

        const idUsuarioNuvem = sessionStorage.getItem('user:useidnuvem');
        if (idUsuarioNuvem) {
          const idNum = parseInt(idUsuarioNuvem);
          let vend = null;
          if (!isNaN(idNum)) {
            vend = await db.vendedor.where('venidnuvem').equals(idNum).first();
            if (!vend) vend = await db.vendedor.where('vencodigo').equals(idNum).first();
          }
          if (!vend) {
            vend = await db.vendedor.where('venidnuvem').equals(String(idUsuarioNuvem)).first();
          }
          if (!vend) {
            vend = await db.vendedor.where('vencodigo').equals(String(idUsuarioNuvem)).first();
          }
          if (!vend && !isNaN(idNum)) {
            vend = await db.vendedor.get(idNum);
          }

          if (vend) {
            this.nomeVendedor = vend.vennome || vend.nome || vend.descricao;
            sessionStorage.setItem('user:nomevendedor', this.nomeVendedor);
          } else {
            const user = await db.usuario.where('useidnuvem').equals(String(idUsuarioNuvem)).first();
            if (user && user.usenome !== '---') {
              this.nomeVendedor = user.usenome;
              sessionStorage.setItem('user:nomevendedor', this.nomeVendedor);
            } else {
              this.nomeVendedor = 'Vendedor ' + idUsuarioNuvem;
            }
          }
        }
      } catch (err) {
        console.error('Erro ao buscar nome do vendedor logado:', err);
      }
    },

    async $_getEmpresa() {
      try {
        let dadosEmpresa = await db.empresa.toCollection().first();

        if (!dadosEmpresa && navigator.onLine) {
          try {
            const resposta = await this.$_empresa();
            const apiEmpresa = Array.isArray(resposta) ? resposta[0] : resposta;
            if (apiEmpresa) {
              dadosEmpresa = {
                ...formatEmpresa(apiEmpresa),
                empdataatualizacao: new Date().toISOString(),
              };
              await db.empresa.put(dadosEmpresa);
            }
          } catch (e) {
            console.warn('Erro ao buscar empresa via API para salvar no Dexie:', e);
          }
        }

        if (!dadosEmpresa) {
          const param = await db.parametro.toCollection().first();
          if (param && (param.empresa || param.empnomeempresa || param.NomeEmpresa)) {
            dadosEmpresa = param;
          }
        }

        if (dadosEmpresa) {
          this.$store.commit('empresa/SET_DADOS', dadosEmpresa);

          const idEmpresa = dadosEmpresa.empidempresa || dadosEmpresa.idempresa || dadosEmpresa.empidnuvem || dadosEmpresa.empresa;
          if (idEmpresa) {
            sessionStorage.setItem('empidempresa', idEmpresa);
          }

          this.empresa = dadosEmpresa.empnomeempresa || dadosEmpresa.NomeEmpresa || dadosEmpresa.empnomefantasia || dadosEmpresa.empresa || dadosEmpresa.nome || 'Empresa';

          const data = dadosEmpresa.empdataalteracao || dadosEmpresa.empdataatualizacao || dadosEmpresa.databaixado || dadosEmpresa.empdatacargaitenstablet || dadosEmpresa.pardataalteracao; 
          
          if (data) {
            this.dataatt = moment(data).format('DD/MM/YYYY - HH:mm:ss');
            const ultimoAcesso = Date.parse(data);
            const now = Date.parse(moment(new Date()));
            if (now - ultimoAcesso >= 1800000) {
              this.icon = 'mdi-alert-circle';
            } else {
              this.icon = null;
            }
          }
        } else {
          console.warn('Nenhum registro de empresa encontrado no Dexie local.');
        }
      } catch (err) {
        console.error('Erro ao carregar empresa no NavigationDrawer:', err);
      }
    },

    async $_criaModulosMenu() {
      try {
        if (!navigator.onLine) {
          this.loadingModulos = false;
          return;
        }
        const menuArray = [];
        for (let i = 1; i < this.menu.length; i += 1) {
          menuArray.push(this.$_Acesso({
            nomeDescricao: `LIBERA ${(this.menu[i].label).toUpperCase()} NO MENU`,
            nomeRotina: `MENU_${(this.menu[i].label).toUpperCase()}`,
            nomePrograma: 'MENU',
            nomeModulo: 'APP',
          }));
        }
        await this.$_geraMenu((await Promise.all(menuArray)));
      } catch (err) {
        console.warn('Erro ao carregar permissões do menu (dispositivo offline):', err);
        this.loadingModulos = false;
      }
    },

    async $_geraMenu(tempMenu) {
      let newMenu = [];
      let liberar = true;
      let temAPagar = false;
      let temAReceber = false;
      newMenu.push(this.menu[0]);
      setTimeout(() => {
        try {
          for (let i = 0; i < tempMenu.length; i += 1) {
            if (!tempMenu[i]) {
              if (this.menu[i + 1].label === 'Financeiro Pagar') {
                temAPagar = true;
              } else if (this.menu[i + 1].label === 'Financeiro Receber') {
                temAReceber = true;
              } else {
                liberar = false;
              }
            }
          }

          // Bloqueios
          if (temAPagar && temAReceber && liberar) {
            // POSSUI AMBOS OS FINANCEIROS LIBERADOS APENAS
            newMenu = this.menu;
          } else if (temAPagar && liberar) {
            // SÓ POSSUI O APAGAR LIBERADO
            for (let i = 0; i < tempMenu.length; i += 1) {
              if (this.menu[i + 1].label !== 'Financeiro Receber') {
                newMenu.push(this.menu[i + 1]);
              }
            }
          } else if (temAReceber && liberar) {
            // SÓ POSSUI O RECEBER LIBERADO
            for (let i = 0; i < tempMenu.length; i += 1) {
              if (this.menu[i + 1].label !== 'Financeiro Pagar') {
                newMenu.push(this.menu[i + 1]);
              }
            }
          } else if (!liberar) {
            // MANUAL
            for (let i = 0; i < tempMenu.length; i += 1) {
              if (!tempMenu[i]) {
                newMenu.push(this.menu[i + 1]);
              }
            }
          } else {
            // NÃO POSSUI NENHUM FINANCEIRO MARCADO
            for (let i = 0; i < tempMenu.length; i += 1) {
              if ((this.menu[i + 1].label !== 'Financeiro Pagar') && (this.menu[i + 1].label !== 'Financeiro Receber')) {
                newMenu.push(this.menu[i + 1]);
              }
            }
          }
          this.menu = newMenu;
        } catch (e) {
          console.warn('Erro ao filtrar menu:', e);
        } finally {
          this.loadingModulos = false;
        }
      }, 0);
    },
  },

  async created() {
    this.menu = menuMapper(this, MENU);
    await this.$_getEmpresa();
    await this.$_buscarNomeVendedor();
    await this.$_criaModulosMenu();

    ToggleNavigationDrawerEvent.on(this.$_toggleNavigationDrawerHandler);

    // TRAZER ID DO USUARIO, SALVAR NO BANCO LOCAL
    // SetupEnvioLocal();
    // clearInterval(sessionStorage.getItem('id-interval-lotec'));
    // const idInterval = setInterval(() => {
    //   SetupEnvioLocal({ silent: true });
    // }, 3000);
    // sessionStorage.setItem('id-interval-lotec', idInterval);
  },

  beforeDestroy() {
    ToggleNavigationDrawerEvent.off(this.$_toggleNavigationDrawerHandler);
  },

};
</script>

<style scoped>
    .sair {
      cursor: pointer;
      transition: 0.2s;
    }

    .sair:hover {
      background-color: rgb(245, 245, 245);
    }

    .subtitle {
      font-size: 10px;
      margin-top: 10px;
    }

    .aviso {
      position: absolute;
      transform: translate(10px,-2px);
      background-color: white;
      border-radius: 100%;
    }
</style>
